import { TIME_FILTERS_VALUES } from "./timeFiltersValues";
import { FILTER_TYPE } from "../../calendar-common/constants/filterType";
import { VOLATILITY_FILTER_OPTIONS } from "./volatilityFilterOptions";
import {
    COUNTRY_FILTER_OPTIONS,
    getMajorCountries,
    getBasicCountries,
} from "./countryFilterOptions";
import { CATEGORY_FILTER_OPTIONS } from "./categoryFilterOptions";
import { getKeysOfNotNullValues } from "../../common/helpers/objects";
import { CALENDAR_VIEW } from "../../calendar-common/constants";

const SETTING_KEYS = {
    Settings: "calendarSettings",
};

const INITIAL_SETTING = {
    timezoneOffset: 0,
    notificationSoundOn: false,
    actualFilterType: FILTER_TYPE.default,
    view: CALENDAR_VIEW.Configure_View_Default,
    filter: {
        type: FILTER_TYPE.default,
        time: TIME_FILTERS_VALUES.RecentNext,
        volatilities: getKeysOfNotNullValues(VOLATILITY_FILTER_OPTIONS).map(
            (x) => VOLATILITY_FILTER_OPTIONS[x]
        ),
        countries: getMajorCountries(
            getKeysOfNotNullValues(COUNTRY_FILTER_OPTIONS)
        ).map((x) => COUNTRY_FILTER_OPTIONS[x]),
        categories: getKeysOfNotNullValues(CATEGORY_FILTER_OPTIONS).map(
            (x) => CATEGORY_FILTER_OPTIONS[x]
        ),
        dateRange: {
            from: null,
            to: null,
        },
    },
};

const BASIC_SETTINGS = {
    timezoneOffset: 0,
    notificationSoundOn: false,
    actualFilterType: FILTER_TYPE.basic,
    view: CALENDAR_VIEW.Configure_View_Basic,
    filter: {
        type: FILTER_TYPE.basic,
        time: TIME_FILTERS_VALUES.RecentNext,
        volatilities: [
            VOLATILITY_FILTER_OPTIONS.Volatility_Medium,
            VOLATILITY_FILTER_OPTIONS.Volatility_High,
        ],
        countries: getBasicCountries(
            getKeysOfNotNullValues(COUNTRY_FILTER_OPTIONS)
        ).map((x) => COUNTRY_FILTER_OPTIONS[x]),
        categories: getKeysOfNotNullValues(CATEGORY_FILTER_OPTIONS).map(
            (x) => CATEGORY_FILTER_OPTIONS[x]
        ),
        dateRange: {
            from: null,
            to: null,
        },
    },
};

const INITIAL_EMPTY_SETTING = {
    timezoneOffset: 0,
    notificationSoundOn: false,
    actualFilterType: FILTER_TYPE.custom,
    view: CALENDAR_VIEW.Configure_View_Basic,
    filter: {
        type: null,
        time: null,
        volatilities: [],
        countries: [],
        categories: [],
        dateRange: {
            from: null,
            to: null,
        },
    },
};

export { SETTING_KEYS, INITIAL_SETTING, BASIC_SETTINGS, INITIAL_EMPTY_SETTING };
